import createReducer from '../utils/createReducer';
import actions from '../actions/informationPage';
import infoMessageMapper from '../utils/infoMessageMapper';

const initialState = {};

const actionHandlers = {
    [actions.POPULATE_INFORMATION_PAGE_MESSAGE](state, {payload}) {
        const {messageKey, ineligibilityStatus, brandName, siteName} = payload;
        const infoMessages = infoMessageMapper(messageKey, ineligibilityStatus, brandName, siteName);
        return {
            ...state,
            header_1: infoMessages.header_1,
            header_2: infoMessages.header_2,
            subHeading: infoMessages.subHeading,
            contents: infoMessages.contents,
            email: infoMessages.email,
            help: infoMessages.help
        };
    },

    [actions.IS_EMAIL_ICON_HOVERED](state, {payload}) {
        return {
            ...state,
            emailIconHoverStatus: payload.emailIconHoverStatus
        };
    },

    [actions.IS_HELP_ICON_HOVERED](state, {payload}) {
        return {
            ...state,
            helpIconHoverStatus: payload.helpIconHoverStatus
        };
    },

    [actions.UPDATE_INELIGIBILITY_STATUS_CODE](state, {payload}) {
        return {
            ...state,
            ineligibilityStatusCode: payload.statusCode
        };
    }
};

export default createReducer(actionHandlers, initialState);
